import type { CreateOrganizationRelationshipResponseDto } from '@evimo/client/models/CreateOrganizationRelationshipResponseDto';
import { useRelationshipTableColumns } from '~/app/hooks/organisationRelationship/useRelationshipTableColumns';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

type Props = {
  relationships: CreateOrganizationRelationshipResponseDto[];
  orgMap: Map<string, string>;
  onEdit: (rel: CreateOrganizationRelationshipResponseDto) => void;
  onDelete: (id: string) => void;
  isDeleting: boolean;
};

export function RelationshipTable({
  relationships,
  orgMap,
  onEdit,
  onDelete,
  isDeleting,
}: Props) {
  const { flatColumns } = useRelationshipTableColumns({
    orgMap,
    onEdit,
    onDelete,
    isDeleting,
  });

  return (
    <EvimoTable
      className="app-table"
      columns={flatColumns}
      dataSource={relationships}
      rowKey="id"
      pagination={{ pageSize: 10, showSizeChanger: true }}
      onRow={(record) => ({
        onClick: () => onEdit(record),
        style: { cursor: 'pointer' },
      })}
    />
  );
}
